<template>
    <div class="modal-inner-content">
      <div class="row-wrapper">
        <b-row>
          <b-col class="bTxt">{{ bookedTariff.name || '' }}</b-col>
          <b-col class="bPriceSum">{{ this.getTariffVolume().amount }}{{ units[this.getTariffVolume().unit] }}</b-col>
        </b-row>
      </div>
      <PromoConsumptionProgressAddedVolume v-for="(incentive) in volumeCompositionPromotions"
                                           :key="incentive.incentiveId"
                                           :description="incentive.description"
                                           :amount="incentive.amount"
                                           :unit="incentive.unit"
                                           :expirationDate="incentive.expirationDate"
                                           context="REGISTER_MEMBER"
                                           :default=false
      >
        <template v-for="slot in possibleChildSlotsFor('AddedVolume')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </PromoConsumptionProgressAddedVolume>
      <div class="row-wrapper" v-for="(option, index) in volumeCompositionTariffOptions" :key="option.id + ' ' + index">
        <hr>
        <b-row>
          <b-col class="bTxt">
            <div>
              {{ option.name }}<br>
              <span class="promo-expiry-date">
                <span v-if="aboOptionCancelable(option)"><slot name="txtCancellable">verlängert sich am</slot></span>
                <span v-else-if="showEndOfRuntime(option)"><slot name="txtEndOfRuntime">gültig bis</slot></span>
                <span v-if="showEndOfRuntime(option) && option.expirationDate === null">&nbsp;{{ dateFormatter(new Date(option.activeRuntime.endOfRuntime)) }}</span>
                <span v-else-if="showEndOfRuntime(option) && option.expirationDate !== null">&nbsp;{{ dateFormatter(new Date(option.expirationDate)) }}</span>
              </span>
            </div>
          </b-col>
          <b-col class="bPriceSum">
            <div class="bVolume">
              {{ option.dataVolume.amount }}{{ units['GB'] }}
            </div>
          </b-col>
        </b-row>
      </div>
      <hr class="last">
      <b-row>
        <b-col class="bTxt sumTxt"><slot name="txtCompositionTotal">Insgesamtes Datenvolumen</slot></b-col>
        <b-col class="bPriceSum">{{ this.volumeCompositionTotalAmount }}{{ units['GB'] }}</b-col>
      </b-row>
    </div>
</template>

<script>

import formatDecimal from '@/mixins/formatters/formatDecimal'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import syncProperty from '@/mixins/syncProperty'
import customerContractState from '@/mixins/customerContractState'
import { mapGetters } from 'vuex'
import transaction from '@/mixins/transaction'
import beErrors from '@/mixins/beErrors'
import PromoConsumptionProgressAddedVolume from '@/components/generic/Promotions/ConsumptionProgressAddedVolume.vue'

export default {
  name: 'VolumeComposition',
  components: { PromoConsumptionProgressAddedVolume },
  mixins: [
    formatDecimal,
    dateFormatter,
    syncProperty('loaded', 'loaded_'),
    transaction('tariffBreakConsumption'),
    customerContractState(),
    beErrors
  ],
  props: {
    bookedTariffOptions: {
      type: Array,
      default: () => []
    },
    separateConsumptions: {
      type: Array,
      default: () => []
    },
    units: {
      type: Object,
      default: () => {}
    },
    bookedTariff: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getTariffVolume () {
      if (typeof this.bookedTariff.volumes !== 'undefined' && typeof this.bookedTariff.volumes[0] !== 'undefined') {
        return this.bookedTariff.volumes[0]
      }
      return null
    },
    aboOptionCancelable (option) {
      return option.automaticExtension && option.statusKey === 'CDL' && !this.contractDismissedInFuture
    },
    showEndOfRuntime (option) {
      return !option.automaticExtension || (option.automaticExtension && ['CAN', 'TER'].includes(option.statusKey)) || !this.contractDismissedInFuture
    }
  },
  computed: {
    volumeCompositionTariffOptions () {
      const options = []
      this.activeBookedTariffOptions.forEach(item => {
        const separatelyListed = this.separateConsumptions.find(consumption => {
          return parseInt(consumption.id) === parseInt(item.tariffoptionId)
        })
        if (!separatelyListed) {
          options.push(item)
        }
      })
      return options
    },
    volumeCompositionPromotions () {
      const options = []
      if (this.volumeIncentivesForCurrentTariff && this.volumeIncentivesForCurrentTariff.length > 0) {
        this.volumeIncentivesForCurrentTariff.forEach(item => {
          const separatelyListed = this.separateConsumptions.find(consumption => parseInt(consumption.id) === parseInt(item.promotionId))
          if (!separatelyListed) {
            options.push(item)
          }
        })
      }
      return options
    },
    volumeCompositionTotalAmount () {
      let total = 0
      if (this.getTariffVolume() !== null) {
        total += this.getTariffVolume().amount
      }
      this.volumeCompositionTariffOptions.forEach(item => {
        total += item.dataVolume?.amount ? item.dataVolume?.amount : 0
      })
      this.volumeCompositionPromotions.forEach(item => {
        total += item.amount ? item.amount : 0
      })
      return total
    },
    bookedTariffOptionsWithVolume () {
      const options = []
      this.bookedTariffOptions.forEach(option => {
        let dataVolume = null
        for (let i = 0; i < option.volumes?.length; i++) {
          if (option.volumes[i].type === 'data') {
            dataVolume = option.volumes[i]
          }
        }
        const prepared = Object.assign(
          option,
          { dataVolume: dataVolume }
        )
        options.push(prepared)
      })
      return options
    },
    activeBookedTariffOptions () {
      return this.bookedTariffOptionsWithVolume.filter((option) => {
        return ['CDL', 'CAN', 'TER'].includes(option.statusKey)
      })
    },
    ...mapGetters('promotion/activePromotions', [
      'volumeIncentivesForCurrentTariff'
    ])
  }
}
</script>
